import { render } from "./AdViewOffer.vue?vue&type=template&id=0b1ae06a&scoped=true"
import script from "./AdViewOffer.vue?vue&type=script&lang=js"
export * from "./AdViewOffer.vue?vue&type=script&lang=js"

import "./AdViewOffer.vue?vue&type=style&index=0&id=0b1ae06a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/colordemy-customers/colordemy-customers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1ae06a"]])

export default __exports__